import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getFhirJson = async (foi = null, fli = null, apiToken = null) => {
    if (!apiToken) {
        //console.log("CALLING SERVER with getfhirresource");
        return await axios({
            method: 'POST',
            url: fevir_node_server_address,
            timeout: 120000,
            data: {
                "functionid": "getfhirresource",
                "resourceid": foi,
                "fli": fli
            },
        }).then((resp) => {
            if (resp?.data) {
                //resp.data is an object with {
                //  'success': true, 'found': true, 'foi': resourceId,
                //   'fhirjsonstring': data.toolstatestring, 'title': title, 'status': status,
                //   'loggedin': loggedin, 'readpermission': true, 'editpermission': editpermission,
                //  'adminpermission': adminpermission, "resourcetype": resourceTypeFound,
                //   "commentsdict": {}    }
                if (resp.data.fhirjsonstring) {
                    return JSON.parse(resp.data.fhirjsonstring);
                } else if (resp.data.found) {
                    return null;
                }
            }
            console.log("NO RESPONSE from getfhirresource call");
        }).catch((error) => { console.log(error); });
    }
    //console.log("CALLING SERVER with getresourcejson")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            "functionid": "getresourcejson",
            "resourceid": foi,
            "apiToken": apiToken,
            "fli": fli
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is Resource JSON as an object
            return resp.data;
        }
        console.log("NO RESPONSE from getresourcejson call");
    }).catch((error) => { console.log(error); });
};

export default getFhirJson;